import type { HttpErrorResponse } from '@angular/common/http';

import { MailboxProtectedDomains } from '@recruitee/mailbox-types';
import { createSingleEntityStore, pipeState } from '@recruitee/ngrx';

import { CandidateCountResponse } from './mailbox-protected-domains.http-client';

const { actions, reducer, namespace, selectors } =
  createSingleEntityStore<MailboxProtectedDomains | null>()('mailbox-protected-domains', {
    customActions: adapter => ({
      update: (state, payload: { domain: string }) => adapter.markAsPending(state),
      deleteProtectedDomain: (state, payload: { domain: string }) => adapter.markAsPending(state),
      deleteProtectedDomainSuccess: (state, payload: MailboxProtectedDomains) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      deleteProtectedDomainFailed: (state, payload: { error: HttpErrorResponse }) =>
        pipeState(state, next => adapter.setError(next, payload.error)),
      getCandidateCount: (state, payload: { domains: string[] }) => adapter.markAsPending(state),
      getCandidateCountSuccess: (state, { payload }: { payload: CandidateCountResponse }) =>
        pipeState(
          state,
          next => ({
            ...next,
            data: {
              ...next.data,
              candidateCount: payload.count,
              protectedDomains: next.data?.protectedDomains ?? [],
            },
          }),
          next => adapter.markAsLoaded(next),
        ),

      getCandidateCountFailed: (state, payload: { error: HttpErrorResponse }) =>
        pipeState(state, next => adapter.setError(next, payload.error)),
    }),
  });

const MailboxProtectedDomainsActions = <
  Pick<
    typeof actions,
    | 'fetch'
    | 'fetchSuccess'
    | 'fetchFailed'
    | 'update'
    | 'updateSuccess'
    | 'updateFailed'
    | 'deleteProtectedDomain'
    | 'deleteProtectedDomainSuccess'
    | 'deleteProtectedDomainFailed'
    | 'getCandidateCount'
    | 'getCandidateCountSuccess'
    | 'getCandidateCountFailed'
  >
>actions;

export {
  MailboxProtectedDomainsActions,
  actions,
  reducer as MailboxProtectedDomainsReducer,
  namespace as MailboxProtectedDomainsNamespace,
  selectors as MailboxProtectedDomainsSelectors,
};
